import styled from "styled-components";

const HamburgerMenuMobileWrapper = styled.div`
  .menu-item-list {
    .svg-wrapper,
    li i svg {
      height: 2rem;
      width: 2rem;
    }
    li i svg {
      margin: 0;
    }
  }
`;

const HamburgerMenuMobileHomeSectionWrapper = styled.div`
  & > div {
    ul {
      padding: 0 1rem;
      overflow: hidden;
      li {
        &:hover {
          &:before {
            content: "";
            left: -1.9rem;
          }
        }
      }
    }
    .item_active {
      &:before {
        content: "";
        left: -1.9rem;
      }
    }
  }
`;

export { HamburgerMenuMobileWrapper, HamburgerMenuMobileHomeSectionWrapper };
